import $ from 'jquery';

const TradeInOrderCreate = (() => {
  const returnDeviceChangeHandler = $input => {
    const index = $input.closest('li').index();
    const $dropdown = $input.closest('.js__order-return-device-type-toggle');
    const $selectedItem = $dropdown.find(`.item[data-value="${$input.val()}"]`);
    const deviceType = $selectedItem.data('type');
    const dropdownCount = $('.js__order-return-device-type-toggle input.dropdown').length;

    if (!$selectedItem.length) {
      return;
    }

    if (deviceType === 'multi_set') {
      const $firstTypeDropdown = $($input.closest('.items').find('li:not(.buttons)')[0]);
      const $secondTypeDropdown = $($input.closest('.items').find('li:not(.buttons)')[1]);
      if (index === 0) {
        $secondTypeDropdown.remove();
      } else if (index === 1) {
        $firstTypeDropdown.remove();
      }
    } else if (dropdownCount === 1) {
      $('.js__add-button').click();
    }
  };

  const init = () => {
    const $form = $('form.js__trade_in_order');

    if (!$form.length) {
      return;
    }

    const $addButton = $('.js__add-button');
    let $returnDeviceInput = $('.js__order-return-device-type-toggle input');

    $addButton.closest('.js__buttons').hide();

    if (!$returnDeviceInput.length) {
      $addButton.click();
      $returnDeviceInput = $('.js__order-return-device-type-toggle input');
    }

    $returnDeviceInput.on('change', e => {
      returnDeviceChangeHandler($(e.currentTarget));
    });

    $addButton.on('click', () => {
      init();
    });
  };

  return {
    init: init,
  };
})();

export default TradeInOrderCreate;
